"use strict";

angular.module('api_configuration', [])
  .constant('api_url', process.env.API_URL)
  .constant('api_path', process.env.API_PATH)
  .constant('api_server', process.env.API_SERVER);
